/**
 * SocialMediaPostService
 * Service for SocialMediaPost entity operations
 * Route: api/socialmedia/posts
 */
import { BaseService } from '../base/BaseService';
/**
 * SocialMediaPostService
 * Handles social media post queries and metrics
 */
export class SocialMediaPostService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SocialMediaPostService.DEFAULT_SERVICE_PATH,
            basePath: SocialMediaPostService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY ID ====================
    /**
     * Get post by ID
     * GET api/socialmedia/posts/{id}
     */
    async getById(id) {
        const response = await this.getByIdRaw(id);
        if (!response.data) {
            throw new Error(`Post ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get post by ID with full response
     */
    getByIdRaw(id) {
        const endpoint = this.getEndpoint('get', id);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET BY ACCOUNT ====================
    /**
     * Get posts by account ID
     * GET api/socialmedia/posts/account/{accountId}
     */
    async getByAccount(accountId) {
        const response = await this.getByAccountRaw(accountId);
        return response.data ?? [];
    }
    /**
     * Get posts by account ID with full response
     */
    getByAccountRaw(accountId) {
        const endpoint = this.getEndpoint('by-account', `account/${accountId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET TOP PERFORMING ====================
    /**
     * Get top performing posts for an account
     * GET api/socialmedia/posts/account/{accountId}/top-performing?metricType={metricType}&limit={limit}
     */
    async getTopPerforming(accountId, metricType = 'Engagement', limit = 10) {
        const response = await this.getTopPerformingRaw(accountId, metricType, limit);
        return response.data ?? [];
    }
    /**
     * Get top performing posts with full response
     */
    getTopPerformingRaw(accountId, metricType = 'Engagement', limit = 10) {
        const endpoint = this.getEndpoint('top-performing', `account/${accountId}/top-performing`);
        const url = this.buildUrl(endpoint);
        const urlWithParams = `${url}?metricType=${encodeURIComponent(metricType)}&limit=${limit}`;
        return this.http.get(urlWithParams);
    }
    // ==================== DELETE ====================
    /**
     * Delete a post
     * DELETE api/socialmedia/posts/{id}
     */
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success ?? false;
    }
    /**
     * Delete a post with full response
     */
    deleteRaw(id) {
        const endpoint = this.getEndpoint('delete', id);
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
SocialMediaPostService.DEFAULT_SERVICE_PATH = 'socialmedia';
SocialMediaPostService.BASE_PATH = 'api/socialmedia/posts';
//# sourceMappingURL=SocialMediaPostService.js.map